// One parking lot, opened by tapping its polygon or its label.
//
// The label on the map is deliberately two facts wide — what the lot is called
// and what it is doing this minute — because it has to be readable among
// fifteen others while somebody is looking for a building. Everything that did
// not fit is here, and it is the half a driver actually needs before setting
// off:
//
//  · The HOURS behind the badge. "Open to all now" is true and expires; without
//    "Monday to Friday, 7:30 AM – 4:30 PM" beside it, somebody reads a permit
//    lot at 5pm as a permit lot at 9am tomorrow.
//  · The WHOLE tariff, not the money alone — "$2.25 / ½hr (1st hr)" and the
//    daily maximum are what the cost actually is.
//  · The HonkMobile zone, which is on no sign this map can draw and is the
//    number you type into the app standing at the machine. Several lots share
//    one, so it cannot be guessed from the lot's letter.
//
// A card, not the Nearby sheet: a lot is not a place you walk to (it has no
// door node and nothing to route to), so borrowing that sheet would offer a
// Directions button that cannot work. The bike racks, which DO have a node, get
// that button on the same card — see BikeParkingCard.
import MapInfoCard from './MapInfoCard.jsx';

export default function ParkingLotCard({ lot, onClose }) {
  if (!lot) return null;
  return (
    <MapInfoCard
      color={lot.colors?.fill}
      title={lot.name}
      // statusNow rather than status: the map drops the badge beside a price,
      // because there it would be the same fact twice. A card read one lot at a
      // time cannot — a missing row is a missing fact.
      status={lot.statusNow || lot.status}
      note={lot.rate}
      facts={[
        ['Restricted', lot.hours],
        ['Time limit', lot.timeLimit],
        ['Daily max', lot.dailyMax],
        ['HonkMobile zone', lot.zone],
      ]}
      // Only where the data has a link. Eleven of the priced areas take payment
      // another way, and a dead "Pay here" is worse than none.
      action={lot.payLink ? { label: 'Pay with HonkMobile', href: lot.payLink } : null}
      onClose={onClose}
    />
  );
}
